import { Modal } from "@findemdev/maui"
import { CredentialLibraryModificationType } from "../CreateUpdateCredential/CreateUpdateCredential"

interface IModifyLibraryProps {
  credLibraryModifiedType: CredentialLibraryModificationType;
  isVisibleConfirmModifyLibraries: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

const ModifyLibrary = ({ credLibraryModifiedType, isVisibleConfirmModifyLibraries, isSubmitDisabled, onCancel, onSubmit }: IModifyLibraryProps) => {
  return <Modal
    title={credLibraryModifiedType === CredentialLibraryModificationType.ADD ? "Add to Library" : "Remove from Library"}
    okText={credLibraryModifiedType === CredentialLibraryModificationType.ADD ? "Add" : "Remove"}
    open={isVisibleConfirmModifyLibraries}
    onCancel={onCancel}
    onOk={onSubmit}
    okButtonProps={{ disabled: isSubmitDisabled }}
    cancelButtonProps={{ disabled: isSubmitDisabled }}
  >
    {credLibraryModifiedType === CredentialLibraryModificationType.ADD
      ? "Are you sure you want to include this credential in the Cred Library as it will be viewable by all users?"
      : "Are you sure you want to remove this credential from the Cred Library?"}
  </Modal>
}

export default ModifyLibrary;